import { useTranslation } from 'react-i18next'

interface Props {
  planName: string
  startsAt: string
  /** The renewal discount, when the gym gave it. */
  discountPercent?: number | null
  gymTimezone: string | null
}

/**
 * The plan bought to follow the current one. It starts the day after the
 * current plan ends, and moves up by itself if the current one ends early.
 */
export function NextPlanLine({ planName, startsAt, discountPercent, gymTimezone }: Props) {
  const { t } = useTranslation()
  // A plan starting at midnight at the gym is stored as the evening before in UTC.
  const date = new Date(startsAt).toLocaleDateString(undefined, {
    timeZone: gymTimezone ?? undefined,
  })
  return (
    <p className="text-xs text-foreground/55">
      {t('membership.nextPlan', { plan: planName, date })}
      {discountPercent != null &&
        ` · ${t('membership.renewalDiscount', { percent: discountPercent })}`}
    </p>
  )
}
